import { createAction, props } from "@ngrx/store";

export const loadOrderDataAction = createAction("[Order] Load Data", props<{ payload: any }>());

export const removeTimeStampFromOrderDataAction = createAction(
  "[Order] Remove TimeStamp From Order Data",  
  props<{ payload: any }>()
);

export const createReturnOrderAction = createAction("[Return Order] Create Return Order", props<{ payload: any }>());

export const fillReturnOrderAction = createAction("[Return Order] Fill Return Order data", props<{ payload: any }>());
export const addItemToReturnOrderAction = createAction(
  "[Return Order] Add Item To Return Order",
  props<{ payload: any }>()
);

export const removeItemFromReturnOrderAction = createAction(
  "[Return Order] Remove Item From Return Order",
  props<{ payload: any }>()
);

export const clearItemsFromReturnOrderAction = createAction("[Return Order] Clear Items From Return Order");

export const updateItemFromReturnOrderAction = createAction(
  "[Return Order] Update Item From Return Order",
  props<{ payload: any }>()
);
export const updateOrderAddressFromReturnOrderAction = createAction(
  "[Return Order] Update order Address From Return Order",
  props<{ payload: any }>()
);

export const updateReturnToAddressFromReturnOrderAction = createAction(
  "[Return Order] Update ReturnTo Address From Return Order",
  props<{ payload: any }>()
);

export const updateDeliveryOptionInReturnOrder = createAction(
  "[Return Order] Update Delivery Option In Return Order",
  props<{ payload: any }>()
);

export const addLabelToReturnOrder = createAction(
  "[Return Order] Add Label Into Return Order",
  props<{ payload: any }>()
);

export const addfreeTextToReturnOrder = createAction(
  "[Return Order] Add Free Text To Return Order",
  props<{ payload: any }>()
);

export const removeLabelFromReturnOrder = createAction("[Return Order] Remove Label From Return Order");
